export default [
  {
    path: '/no-permission',
    component: () => import('./index'),
    name: 'no-permission',
    meta: {
      parentName: '/no-permission',
      menuRender: false, // 不渲染菜单
    },
  },
];
